import { render, staticRenderFns } from "./TrainingCoursesFiles.vue?vue&type=template&id=2b25bdbe&"
import script from "./TrainingCoursesFiles.vue?vue&type=script&lang=js&"
export * from "./TrainingCoursesFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports